var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00CEBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.35,
    d: "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00CEBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.35,
    d: "m15.709 15.18-3.1-1.85c-.54-.32-.98-1.09-.98-1.72v-4.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGreen);
export default __webpack_public_path__ + "static/media/clockGreen.24b6337a504e53010b2b0970afafc01a.svg";
export { ForwardRef as ReactComponent };